function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var MidBreakSeekingEventsAddon = /*#__PURE__*/ function() {
    "use strict";
    function MidBreakSeekingEventsAddon(session) {
        var _this = this;
        _class_call_check(this, MidBreakSeekingEventsAddon);
        _define_property(this, "session", void 0);
        _define_property(this, "currentAdBreak", void 0);
        _define_property(this, "currentAd", void 0);
        this.session = session;
        this.currentAdBreak = null;
        this.currentAd = null;
        this.session.onAdBreakStarted(function(adBreak) {
            _this.currentAdBreak = adBreak;
        });
        this.session.onAdBreakFinished(function(adBreak) {
            _this.currentAdBreak = null;
        });
        this.session.onAdStarted(function(ad) {
            _this.currentAd = ad;
        });
        this.session.onAdFinished(function(ad) {
            _this.currentAd = null;
        });
    }
    _create_class(MidBreakSeekingEventsAddon, [
        {
            key: "handleSeekStarted",
            value: function handleSeekStarted(destinationAdPosition) {
                if (destinationAdPosition) {
                    this.handleSeekingWithinBreak(destinationAdPosition);
                } else {
                    this.handleSeekOutOfBreak();
                }
            }
        },
        {
            key: "handleSeekOutOfBreak",
            value: function handleSeekOutOfBreak() {
                if (this.currentAd) {
                    this.session.notifyAdFinished(this.currentAd);
                }
                if (this.currentAdBreak) {
                    this.session.notifyAdBreakFinished(this.currentAdBreak);
                }
            }
        },
        {
            key: "handleSeekingWithinBreak",
            value: function handleSeekingWithinBreak(destinationAdPosition) {
                if (this.currentAd && destinationAdPosition.ad && destinationAdPosition.ad.id !== this.currentAd.id) {
                    this.session.notifyAdFinished(this.currentAd);
                }
                if (this.currentAdBreak && destinationAdPosition.adBreak.id !== this.currentAdBreak.id) {
                    this.session.notifyAdBreakFinished(this.currentAdBreak);
                }
            }
        }
    ]);
    return MidBreakSeekingEventsAddon;
}();

//# sourceMappingURL=mid-break-seeking-events-addon.js.map